<template>
    <div id="member">
        <el-col :span="24" class="action-bar">
            <el-button type="primary" size="medium" @click="signatureVisible=true">添加</el-button>
        </el-col>
        

        <!-- 列表 -->
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
                prop="name"
                label="名称"
                width="200"
                >
            </el-table-column>
            <el-table-column
                label="排序"
                prop="sort"
                width="200">
            </el-table-column>
            <el-table-column
                prop="created_at"
                label="创建时间"
                width="200"
                >
            </el-table-column>
            
            
            <el-table-column label="操作" width='200'>
                <template slot-scope="scope">
                    <el-button size="mini" type='primary' @click="editorDemandClassify(scope.row)">编辑</el-button>
                    <el-button size="mini" type='danger' @click="delDemandClassify(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
            
        </el-table>

		<el-dialog title="需求类型" :visible.sync="signatureVisible" @close="initData" >
            <el-form label-width="100px">
                <el-form-item label="名称">
                    <el-input palceholder="输入需求类型名称" v-model="member.content" style="width:400px"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input palceholder="数字越小，排序越前" type="number" v-model="member.sortNum" style="width:400px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="setDemandClassify" >提交</el-button>
			</div>
		</el-dialog>
    </div>
</template>
<script>
export default {
    name:'member',
    data() {
        return {
            signatureVisible:false,//编辑弹窗
            demandTypeId:'',//选中的类型id
            tableData: [{}],
            page:1,
            totalPage:0,
            member:{
                content:'',
                sortNum:''
            }
        }
    },
    methods: {      
        pageChange(e){
			//翻页
			this.page=e;
			this.getDemandClassify();
        },
        async getDemandClassify(){
            //获取列表
            let params={
                page:this.page,
                limit:16,
            }
            let res=await this.$api.getDemandClassify(
                params);
            if(res.data.level=='success'){
                this.tableData=res.data.data;
                this.totalPage=res.data.page_info.total;
            }
        },
        editorDemandClassify(scope){
            this.member.content=scope.name;
            this.member.sortNum=scope.sort;
            this.demandTypeId=scope.id;
            this.signatureVisible=true
        },
        async delDemandClassify(id){
            let judge=null;
            let tit='删除该资讯类别?';
            try {
              judge=  await this.$confirm(tit, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
                })
            } catch (error) {
                judge='cancel'
            }
            if(judge=='confirm'){
                this.delDemandClassifyHandle(id)
            }
            console.log(judge)
        },
        async delDemandClassifyHandle(id){
            let res=await this.$api.delDemandClassify({id:id})
            if(res.data.level=='success'){
                this.$message({
                    type:'success',
                    message:res.data.message
                })
                this.signatureVisible = false
                this.getDemandClassify()
            }else{
                this.$message({
                    type:'error',
                    message:res.data.message
                })
            }
        },
        
        async setDemandClassify(){
            let params={
                name:this.member.content,
                sort:this.member.sortNum,
                id:this.demandTypeId
            }
            let res=await this.$api.setDemandClassify(params)
            if(res.data.level=='success'){
                this.$message({
                    type:'success',
                    message:res.data.message
                })
                this.signatureVisible = false
                this.getDemandClassify()
            }else{
                this.$message({
                    type:'error',
                    message:res.data.message
                })
                
            }
        },

        initData(){
            this.demandTypeId=''
            this.member=this.$options.data().member;
        }

    },
    mounted() {
        this.getDemandClassify()
    },
}
</script>
<style lang="scss" scoped>
.screen{
          margin-top: -10px !important;
      }
    .action-bar{
			background-color: #f2f2f2;
			height: 60px;
			margin: 10px 0px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			padding-left: 20px;
			.action-bar-input{
				width: 250px;
				margin-right: 14px;
      }
      .task-form-text{
				color: #666666;
			}
		}
		.el-table-style{
			width: 100%;
			border: 1px solid #f2f2f2;
		}
		.footer-bar{
			display: flex;
			justify-content: space-between;
			align-items: center;
			background: #f2f2f2;
			padding: 8px;
			margin: 10px 0px;
			box-sizing: border-box;
		}
		.dialog-footer{
			text-align: center;
		}
		.executorList{
			display: flex;
			flex-wrap: wrap;
			div{
				margin:10px;
				border:1px solid #eee;
				border-radius: 5px;
				padding:5px 10px;
			}
		}
</style>


// WEBPACK FOOTER //
// src/pages/demand/demand_type.vue